import { Chip } from '@dxb-web-ui-framework/design-system';
import React, { FC } from 'react';
import { TFunction } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { OrderStatus } from '../domain/Transaction/entities/OrderStatus';
import { useOrderStatuses } from '../contexts/Parameters/hooks';
import { pascalToWords } from '../utils';

export interface TransactionOrderStatusChipProps {
  statusSerialNumber: number;
}

export const getTransactionOrderStatus: (
  statusSerialNumber: number,
  orderStatuses: OrderStatus[],
  t: TFunction,
) => {
  value: string;
  color: 'default' | 'success' | 'info' | 'error' | 'warning';
} = (statusSerialNumber, orderStatuses, t) => {
  const orderStatusDescriptionFound = pascalToWords(
    (orderStatuses.find(os => os.serialNumber === statusSerialNumber) as OrderStatus)?.description,
  );
  switch (statusSerialNumber) {
    case 3:
      return { value: orderStatusDescriptionFound, color: 'info' };
    case 5:
      return { value: orderStatusDescriptionFound, color: 'warning' };
    case 97:
    case 98:
    case 99:
    case 4:
    case 2:
    case 6:
      return { value: orderStatusDescriptionFound, color: 'error' };
    case 1:
      return { value: orderStatusDescriptionFound, color: 'success' };
    case 0:
    default:
      return {
        value: orderStatusDescriptionFound ?? t('orderStatus.0'),
        color: 'default',
      };
  }
};
const TransactionOrderStatusChip: FC<TransactionOrderStatusChipProps> = ({ statusSerialNumber }) => {
  const { t } = useTranslation();
  const orderStatuses = useOrderStatuses();
  return (
    <Chip
      label={getTransactionOrderStatus(statusSerialNumber, orderStatuses, t).value}
      bgColor={getTransactionOrderStatus(statusSerialNumber, orderStatuses, t).color}
    />
  );
};

export { TransactionOrderStatusChip };
